<h2
  [class]="
    feedbackConfig.stages[feedbackConfig.activeStage].title.classes || ''
  "
>
  <dgx-components-icon
    *ngIf="feedbackConfig.stages[feedbackConfig.activeStage].title.icon"
    [name]="feedbackConfig.stages[feedbackConfig.activeStage].title.icon"
  >
  </dgx-components-icon>
  {{ feedbackConfig.stages[feedbackConfig.activeStage].title.text }}
</h2>
<ul *ngIf="configActiveStage.descriptionIsMultipleLines">
  <li
    *ngFor="let line of configActiveStage.description"
    [innerHTML]="line"
  ></li>
</ul>

<p *ngIf="!configActiveStage.descriptionIsMultipleLines">
  {{ configActiveStage.description }}
</p>

<ng-container
  *ngIf="feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput"
>
  <section class="free-text-holder">
    <textarea
      #textArea
      placeholder="Please add a description"
      [ngModel]="feedbackConfig.selectedValue[feedbackConfig.activeStage]"
      (ngModelChange)="freeTextInput($event, textArea)"
      [rows]="5"
    >
    </textarea>

    <span class="character-count">
      <span
        [class.invalid]="
          feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length >
          (feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount ||
            200)
        "
      >
        {{
          feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length || 0
        }}</span
      >/{{
        feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount || 200
      }}
    </span>
  </section>

  <section
    *ngIf="showOptionError"
    class="selection-error"
    style="display: flex; gap: 8px"
  >
    <dgx-components-icon name="circle-exclamation"> </dgx-components-icon>
    <ng-container
      *ngIf="
        feedbackConfig.selectedValue[feedbackConfig.activeStage]?.length >
          (feedbackConfig.stages[feedbackConfig.activeStage].maxCharCount ||
            200);
        else MissingDescription
      "
    >
      You have exceeded the character limit
    </ng-container>

    <ng-template #MissingDescription> Add a description </ng-template>
  </section>
</ng-container>
<ng-container
  *ngIf="feedbackConfig.stages[feedbackConfig.activeStage]?.options"
>
  <section
    *ngFor="
      let option of feedbackConfig.stages[feedbackConfig.activeStage].options
    "
    class="option"
    [class.checked]="
      feedbackConfig.selectedValue[feedbackConfig.activeStage] === option.value
    "
  >
    <input
      type="radio"
      name="why"
      [id]="option.value"
      [value]="option.value"
      [(ngModel)]="feedbackConfig.selectedValue[feedbackConfig.activeStage]"
      (ngModelChange)="showOptionError = false"
    />
    <label [for]="option.value">
      <dgx-components-icon *ngIf="option.icon" [name]="option.icon" size="lg">
      </dgx-components-icon>
      {{ option.label }}
    </label>
  </section>

  <section
    *ngIf="showOptionError"
    class="selection-error"
    style="display: flex; gap: 8px"
  >
    <dgx-components-icon name="circle-exclamation"> </dgx-components-icon>
    Choose an option
  </section>
</ng-container>

<dgx-components-button
  *ngIf="
    feedbackConfig.stages[feedbackConfig.activeStage]?.freeTextInput ||
    feedbackConfig.stages[feedbackConfig.activeStage]?.options
  "
  [variant]="
    feedbackConfig.stages[feedbackConfig.activeStage].button?.variant ||
    'secondary'
  "
  [fill]="true"
  (clicked)="submitFeedback()"
>
  {{
    feedbackConfig.stages[feedbackConfig.activeStage].button?.text ||
      'Send your feedback'
  }}
</dgx-components-button>
